import React from "react";
import capitalize from "lodash/capitalize";

const MultiOptionsInput = ({
  value,
  onChange = () => {},
  options = [],
  inputName = "",
  optionLabels = {},
}) => {
  return (
    <div className="multi-options-container" sz="large">
      <input name={inputName} value={value} hidden />
      {options.map((option, index) => {
        return (
          <div
            className={`color-button${value === option ? " active" : ""}`}
            onClick={() => {
              onChange(inputName, option);
            }}
            key={index}
          >
            <span>{optionLabels[option] ?? capitalize(option)}</span>
          </div>
        );
      })}
    </div>
  );
};

export default MultiOptionsInput;
